import axios from "axios";

export const isCanceledError = (error: unknown): boolean => {
  return (
    axios.isCancel?.(error) === true ||
    (error as { code?: string })?.code === "ERR_CANCELED" ||
    (error as { name?: string })?.name === "CanceledError" ||
    (error as { name?: string })?.name === "AbortError"
  );
};
